import React from "react";
import Modal from "../../../../components/common/Modal";

interface TestDataFormExampleModalProps {
  /** Controls whether the modal is visible */
  isOpen: boolean;
  /** Callback fired when the user closes the modal */
  onClose: () => void;
}

/**
 * TestDataFormExampleModal - Modal for displaying a Test Data form example image.
 *
 * Shows an example image for the Test Data form,
 * opened when the user clicks "Click here for an example of a completed form"
 * in the Test Data Help popup.
 *
 * @param isOpen - Whether the modal is currently visible.
 * @param onClose - Callback to close the modal.
 * @returns The Test Data form example modal component.
 */
const TestDataFormExampleModal: React.FC<TestDataFormExampleModalProps> = ({
  isOpen,
  onClose,
}) => (
  <Modal
    isOpen={isOpen}
    title="Project Data Form Questions & Answers"
    onClose={onClose}
    onSecondary={onClose}
    clearBtn="Close"
    contentClassName="mb-4!"
  >
    <div className="flex flex-col gap-6 py-2">
      <img
        src="/assets/images/test-data-add-new.png"
        alt="Test data add new form example"
        className="w-full rounded"
      />
    </div>
  </Modal>
);

export default TestDataFormExampleModal;
